import { FormControl } from '@angular/forms';

export function ValidateCarRegistration(control: FormControl): any {
  if (!control.value) return null;

  const reg: string = control.value.replace(/\s/g, '');

  if (reg === '') return null;

  const NotMaldonadoRegex = /^[a-zA-Z]{3}[0-9]{4}$/;
  const MaldonadoRegex = /^B[0-9]{3,6}$/;

  if (!reg.match(NotMaldonadoRegex) && !reg.match(MaldonadoRegex))
    return { invalid: true };

  return null;
}
